import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ButtonArrowed from '../widgets/Buttons/ButtonArrowed';

import './tag-select.scss';

class TagSelect extends PureComponent {
  componentDidMount() {
    document.body.addEventListener('click', this.layoutClickHandler);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.layoutClickHandler);
  }

  layoutClickHandler = (event) => {
    if (!this.props.opened && !this.dialog) {
      return;
    }

    if (!this.dialog.contains(event.target)) {
      if (event) {
        event.preventDefault();
      }

      this.props.onTagsToggle();
    }
  };

  render() {
    const {
      tags,
      opened,
      onTagClick,
      onTagsToggle
    } = this.props;

    const activities = tags.filter(tag => !tag.isCompany);
    const companies = tags.filter(tag => tag.isCompany);

    return (
      <div className="tags-select">
        <ButtonArrowed
          onClick={onTagsToggle}
          direction="right"
        >
          поиск по тегам <i>выбрать</i>
        </ButtonArrowed>

        {(opened) &&
          <div
            ref={elem => { this.dialog = elem; }}
            className="tags-dialog"
          >
            <div className="tags-dialog-container">
              <button
                type="button"
                className="btn btn-close"
                onClick={onTagsToggle}
              />

              <h3>Выберите интересующие вас темы:</h3>

              {(activities.length) &&
                <div className="tags-group">
                  <h4>Направления деятельности:</h4>

                  <ul>
                    {activities.map(item =>
                      <li key={item.id}>
                        <button
                          type="button"
                          className={cn({ selected: item.selected })}
                          onClick={() => onTagClick(item.id)}
                        >
                          {item.name}
                        </button>
                      </li>
                    )}
                  </ul>
                </div>
              }

              {(companies.length) &&
                <div className="tags-group">
                  <h4>Компании:</h4>

                  <ul>
                    {companies.map(item =>
                      <li key={item.id}>
                        <button
                          type="button"
                          className={cn({ selected: item.selected })}
                          onClick={() => onTagClick(item.id)}
                        >
                          {item.name}
                        </button>
                      </li>
                    )}
                  </ul>
                </div>
              }

              <div className="tags-dialog-buttons">
                <button
                  className="btn btn-arrowed"
                  onClick={this.props.onSearchClick}
                >
                  Найти <span className="icon">→</span>
                </button>

                <button
                  className="btn"
                  onClick={this.props.onResetClick}
                >
                  Сбросить тэги
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

TagSelect.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      selected: PropTypes.bool,
      isCompany: PropTypes.bool
    })
  ),
  opened: PropTypes.bool,
  onTagClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  onResetClick: PropTypes.func,
  onTagsToggle: PropTypes.func
};

export default TagSelect;



// WEBPACK FOOTER //
// ./src/components/News/TagSelect.js